import { Link } from "react-router-dom";
import { Zap } from "lucide-react";

export const LegalLayout = ({ title, updated, children, testid }) => (
  <main className="shell legal" data-testid={testid}>
    <header className="topbar">
      <Link to="/" className="flex items-center gap-2 no-underline text-inherit"><span className="brand-mark"><Zap size={20} strokeWidth={2.75} /></span><span className="brand-title notranslate" translate="no">DropIt <span className="text-primary">⚡</span></span></Link>
      <Link to="/auth" className="balance-pill">Log in</Link>
    </header>
    <h1 className="text-3xl font-black">{title}</h1>
    <p className="text-xs text-muted mt-1 mb-6">Last updated {updated} · Operator: DropIt (placeholder entity, dropit.fyi)</p>
    <article className="legal-body">{children}</article>
    <footer className="text-xs text-muted mt-10"><Link to="/terms">Terms</Link> · <Link to="/privacy">Privacy</Link> · <Link to="/">Home</Link></footer>
  </main>
);
